import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    title: {
      marginBottom: 8,
    },
    card: {
      backgroundColor: '#fff',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      borderRadius: 8,
      padding: theme.spacing(3),
    },
    section: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      borderTop: '1px solid rgba(0, 0, 0, 0.08)',
      '&:first-child': {
        borderTop: 'none',
        paddingTop: 0,
      },
    },
    sectionTitle: {
      margin: '0 0 16px',
      fontSize: 15,
      fontWeight: 600,
      letterSpacing: 0.4,
      textTransform: 'uppercase',
      color: '#4B8B33',
    },
    photo: {
      width: 96,
      height: 96,
      objectFit: 'cover',
      borderRadius: 8,
      border: '1px solid #e0e0e0',
      display: 'block',
      cursor: 'pointer',
      backgroundColor: '#f5f5f5',
    },
    photoHint: {
      margin: '8px 0 0',
      fontSize: 12,
      color: '#726e6e',
    },
    note: {
      margin: '8px 0 0',
      padding: '10px 12px',
      backgroundColor: '#f7faf6',
      borderRadius: 6,
      color: '#3d3d3d',
      fontSize: 14,
    },
    abilityList: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
      gap: 8,
      margin: '12px 0 0',
      padding: 0,
      listStyle: 'none',
    },
    abilityItem: {
      margin: 0,
      padding: '8px 12px',
      backgroundColor: '#f7faf6',
      borderRadius: 6,
      fontSize: 14,
      color: '#333',
      lineHeight: 1.4,
    },
    extras: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
      marginTop: 8,
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      paddingTop: theme.spacing(2),
      borderTop: '1px solid rgba(0, 0, 0, 0.08)',
    },
}));
